import { IconBook2 } from '@tabler/icons-react'

export const PERMISSION_SETS_PROFILE_CONTENT = {
  id: 'Profile Content',
  description: 'Grant access to view profile content.',
  icon: IconBook2,
  sections: [
    {
      title: 'permissions',
      permissions: [
        {
          type: 'checkbox',
          label: 'View basic information',
          description:
            'Name, photo, language, birth date, gender, employer, title, school, phone numbers, email, and addresses.',
        },
        {
          type: 'checkbox',
          label: 'View health information',
          children: [
            {
              type: 'checkbox',
              label: 'View food allergies',
            },
            {
              type: 'checkbox',
              label: 'View other allergies',
            },
            {
              type: 'checkbox',
              label: 'View medications',
            },
            {
              type: 'checkbox',
              label: 'View health conditions',
            },
            {
              type: 'checkbox',
              label: 'View insurance details',
            },
            {
              type: 'checkbox',
              label: 'View emergency instructions',
            },
            {
              type: 'checkbox',
              label: 'View hospital preferences',
            },
            {
              type: 'checkbox',
              label: 'xxxx',
            },
            {
              type: 'checkbox',
              label: 'xxxx',
            },
            {
              type: 'checkbox',
              label: 'xxxx',
            },
            {
              type: 'checkbox',
              label: 'xxxx',
            },
            {
              type: 'checkbox',
              label: 'xxxx',
            },
            {
              type: 'checkbox',
              label: 'xxxx',
            },
            {
              type: 'checkbox',
              label: 'xxxx',
            },
          ],
        },
        {
          type: 'checkbox',
          label: 'View needs',
          children: [
            {
              type: 'checkbox',
              label: 'View food',
            },
            {
              type: 'checkbox',
              label: 'View housing',
            },
            {
              type: 'checkbox',
              label: 'View cash assistance',
            },
            {
              type: 'checkbox',
              label: 'View education',
            },
            {
              type: 'checkbox',
              label: 'View transportation',
            },
            {
              type: 'checkbox',
              label: 'View health & wellness',
            },
            {
              type: 'checkbox',
              label: 'View family supports',
            },
            {
              type: 'checkbox',
              label: 'View legal',
            },
            {
              type: 'checkbox',
              label: 'View other needs',
            },
          ],
        },
      ],
    },
    {
      title: 'grant location record access',
      permissions: [
        {
          type: 'checkbox',
          label: 'Deactivate staff access',
        },
        {
          type: 'checkbox',
          label: 'Reactivate staff access',
        },
      ],
    },
  ],
}
